import { Component } from '@angular/core';

@Component({
  selector: 'ipm-refer',
  templateUrl: './refer.component.html',
  styleUrls: ['./refer.component.scss']
})
export class ReferComponent {

}
